import { forwardRef, useContext } from "react";
import DropAnchor from "lib/Draggable/DropAnchor";
import { classnames } from "lib/helpers";
import Schema from "./Schema";
import { TreeContext } from "pages/Editor";

function isEmptyList(item) {
  const children = item.children || [];
  return item.type === "LIST" && children.length === 0;
}

function List({ type, children = [], path, style, onlyChild }, ref) {
  const { editable } = useContext(TreeContext);
  const horizontal = type === "Horizontal List";
  const vertical = type === "Vertical List";
  const className = classnames("ls", {
    v: vertical,
    h: horizontal,
    nc: children.length === 0 && onlyChild,
    e: editable,
  });
  const hasOnlyEmptyLists =
    children.filter(isEmptyList).length === children.length;
  function renderChildren(item, i) {
    return (
      <Schema
        component={item}
        // onlyChild is just an alias for hasOnlyEmptyLists
        // it doesn't mean its the only child
        onlyChild={hasOnlyEmptyLists || vertical}
        // issue #7
        path={[path, "children", i].join(".")}
        index={i}
        key={item.name + "-" + i}
      />
    );
  }
  // TODO: add option to make things flex-grow
  // lists are flex: 1 by default
  const hasNoListInChildren =
    children.filter((c) => c.type === "LIST").length === 0;
  const content = children.map(renderChildren);
  return (
    <div {...{ ref, className, style }}>
      {content}
      {editable && (
        <DropAnchor
          {...{ path: path + ".children." + children.length }}
          fill={hasNoListInChildren}
        />
      )}
    </div>
  );
}

export default forwardRef(List);
